import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext'; // Ensure this path is correct for your project

const TopContainer = () => {
  const { logout, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const handleLogout = (e) => {
    e.preventDefault();
    logout();
    navigate('/');
  };

  return (
    <div className="top-container">
      <div className="logo-container">
        <a href="/home">
          <img
            src="https://www.everviz.com/wp-content/uploads/2022/10/everviz_hovedlogo-d.svg"
            alt="Logo"
            className="logo"
          />
        </a>
      </div>
      <div className="nav-container">
        <div className="submenu">
          <a href="/home">Search</a> | <a href="/customers">Customers</a> | <a href="/trialcustomers">Trials</a> | <a href="/activity">Activity</a> | <a href="/mrr">MRR</a>
          
          {isAuthenticated && (
            <>
              {' | '}
              <a 
                href="#logout" 
                onClick={handleLogout} 
                style={{ color: '#ff4b2b', fontWeight: 'bold' }}
              >
                Logout
              </a>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default TopContainer;